(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
function initParse() {
    console.log('parse');
    function hideOptionIDsAndPrices() {
        $('.pplrlabel, .product__description__property.order-summary__small-text, select.pplr_select option, .img_thumb_dropdown span.img_dropdown, .pplr-selecter-selected, span.ppdata').each(function(index, element) {
            var labelSplit = $(element).html();
            console.log('start hide option IDs');
            if (labelSplit.indexOf("|") >= 0) {
              var idSplit = labelSplit.split("|");
              $(element).html(idSplit[0]);
              var skudata = $.trim(idSplit[1])
              $(element).attr({'data-option-sku':skudata});
              //$(element).parent().not('.pplr-cabinet-color').addClass('pplr_option-sku');
              $(element).parent().addClass('pplr_option-sku');
              $('.pplr-wrapper.pplr-cabinet-color').attr({'name':'properties[Cabinet Color]'});
            }
        });
        $('.pplr-wrapper.pplr-cabinet-color .pplr-swatch-element').each(function (index,element) {
          var labelSplit = $(element).data('val');
          if (labelSplit.indexOf("|") >= 0) {
              var idSplit = labelSplit.split("|");
              var skudata = $.trim(idSplit[1])
              $(element).attr({'data-option-sku':skudata});
              //$(element).closest('.pplr-cabinet-color').addClass('pplr_option-sku');
          }
        })
        
    }
    function changeOption(){
      $('.pplr_option-sku').each(function(index, element) {
        var myVar = $(this);
        selectedSKU(myVar);
      })
      $('.pplr_option-sku').change(function () {
        var myVar = $(this);
        selectedSKU(myVar);
      });
    }
    function selectedSKU(myOption) {
        var currentOp = myOption.find(':selected,.selected').data('optionSku');
        var optionName = myOption.attr('name');

        optionName = optionName.toLowerCase();
        if (typeof(currentOp) == "undefined"){
          currentOp = '';
        }
        //console.log(currentOp+' - '+optionName);
        
        if (optionName.indexOf("heat") >= 0) {
          $('.heat_opt').text(currentOp);
        }
        if (optionName.indexOf("ventilation") >= 0) {
          $('.ventilation_opt').text(currentOp);
        }
        if (optionName.indexOf("dehumidification") >= 0) {
          $('.dehumidification_opt').text(currentOp);
        }
        if (optionName.indexOf("controls") >= 0) {
          $('.controls_opt').text(currentOp);
        }
        if (optionName.indexOf("operating") >= 0) {
          $('.operating_opt').text(currentOp);
        }
        if (optionName.indexOf("quality") >= 0) {
          $('.quality_opt').text(currentOp);
        }
        if (optionName.indexOf("air flow") >= 0) {
          $('.air-flow_opt').text(currentOp);
        }
        if (optionName.indexOf("compressor location") >= 0) {
          $('.compressor-location_opt').text(currentOp);
        }
        if (optionName.indexOf("filter") >= 0) {
          $('.filter_opt').text(currentOp);
        }
        if (optionName.indexOf("corrosion protection") >= 0) {
          $('.corrosion-protection_opt').text(currentOp);
        }
        if (optionName.indexOf("engineering revision") >= 0) {
          $('.engineering-revision_opt').text(currentOp);
        }
        if (optionName.indexOf("cabinet color") >= 0) {
          $('.cabinet-color_opt').text(currentOp);
        }
    }
                           
    hideOptionIDsAndPrices();
    changeOption();
}
$(document).on('click','.pplr-cabinet-color .pplr-swatch-element[data-option-sku].selected', function () {
  var myVar = $(this);
  //selectedSKU(myVar);
  var currentOp = $(this).data('optionSku');
  //console.log($(this).data('val'));
  $('.cabinet-color_opt').text(currentOp);
});
function returnLabel(array) {
    var html = '';
    html += array[array.length - 1]
    return html;
}
$(window).on('load', function() {
  initParse();
  var colorOp = $('.pplr-cabinet-color .pplr-swatch-element[data-option-sku].selected').data('optionSku');
  $('.cabinet-color_opt').text(colorOp);
});
